module.exports = __webpack_public_path__ + "static/media/ic-gantt.194bbd94.svg";